import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState, ListView } from 'model/state';
import { Dispatch } from 'redux';
import { LocationRolesView } from 'components';
import { setSelectAll, setSelectRow, clearMessage, openConfirmationDialog, updateLocationSearch, fetchUserLocationsRoles,
  assignUserLocationRoles, 
  incrementLocationPage,
  reinitLocationPageCount} from 'actions';
import { Location, User, PermissionsEnum, LocationFilters } from 'model';
import { selectIsSelectedAll, selectIsSelectedAny, selectSelectedNumber, selectHasErrorMessage, selectIsSubmitting, 
  selectLocationSearch, selectUserId, selectCurrentUser, selectIsGrantFullAccessEnabled, selectIsGrantLimitedAccessEnabled,
  selectIsRevokeAccessEnabled, selectParent, selectSelectedLocations, selectLocationList} from 'selectors';
import { selectIsSubmittingAlertSettings } from 'selectors/Settings';

type SelectedValues = {
  locationList: ListView<Location>,
  isSelectedAll: boolean,
  isSelectedAny: boolean,
  selectedNumber: number,
  hasError: boolean,
  isSubmitting: boolean,
  search: string,
  authUserId?: string | null,
  currentUser: User,
  isGrantFullAccessEnabled: boolean,
  isGrantLimitedAccessEnabled: boolean,
  isRevokeAccessEnabled: boolean,
  parent: Location | null,
  selectedLocations: Location[],
  isSubmittingAlertSettings: boolean,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  locationList: selectLocationList(),
  isSelectedAll: selectIsSelectedAll(),
  isSelectedAny: selectIsSelectedAny(),
  selectedNumber: selectSelectedNumber(),
  hasError: selectHasErrorMessage(),
  isSubmitting: selectIsSubmitting(),
  search: selectLocationSearch(),
  authUserId: selectUserId(),
  currentUser: selectCurrentUser(),
  isGrantFullAccessEnabled: selectIsGrantFullAccessEnabled(),
  isGrantLimitedAccessEnabled: selectIsGrantLimitedAccessEnabled(),
  isRevokeAccessEnabled: selectIsRevokeAccessEnabled(),
  parent: selectParent(),
  selectedLocations: selectSelectedLocations(),  
  isSubmittingAlertSettings: selectIsSubmittingAlertSettings(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchUserLocationsRoles: (authUserId: string, currentUserId: string, parentId: string | undefined, page: number, search: string, filters: LocationFilters) => {
    dispatch(fetchUserLocationsRoles(authUserId, currentUserId, parentId, page, search, filters))
  },
  setSelectAll: (selectAll: boolean) => dispatch(setSelectAll(selectAll)),
  setSelectRow: (selectAll: boolean, locationId: string) => dispatch(setSelectRow(selectAll, locationId)),
  clearMessage: () => dispatch(clearMessage()),
  openConfirmationDialog: (metadata?: { [key: string]: any }) => dispatch(openConfirmationDialog(metadata)),
  updateSearch: (search: string) => dispatch(updateLocationSearch(search)),
  assignUserLocationRoles: (roles: PermissionsEnum[], userId: string) => dispatch(assignUserLocationRoles(roles, userId)),
  incrementPage: () => dispatch(incrementLocationPage()),
  reinitPageCount: () => dispatch(reinitLocationPageCount()),
});


export default connect(mapStateToProps, mapDispatchToProps)(LocationRolesView);
